// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import VueI18n from 'vue-i18n'
import BaiduMap from 'vue-baidu-map'
import api from '@/http/axios'
import locale from 'element-ui/lib/locale/lang/en'


Vue.prototype.$api = api

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'QN4n7mWeoDQSmqV3odgNAA5SSTvpi5U1'
})
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.getItem('languageSet') || 'zh',
  messages: {
    'zh': require('./components/language/zh'),
    'en': require('./components/language/en')
  }
})
if (i18n.locale == 'en') {
  Vue.use(ElementUI, { locale })
}
Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js